import { company_name } from "@/i18n/variables";

const debtors = {
	add_button: "Add Debtor",
	add_debtor: {
		form: {
			common_email_address: {
				label: "General Email Address",
				placeholder: `info@${company_name}.nl`,
			},
			company_address_description:
				"In this section, you can fill in the address details of the company to be created.",
			/* ---------------------------- COMPANY ADDRESS INFO -------------------------- */
			company_address_title: "Address Details",
			company_communication_description:
				"In this section, you can fill in the communication preferences of the company to be created.",
			/* ------------------------- COMPANY COMMUNICATION INFO ---------------------- */
			company_communication_title: "Communication Preferences",
			company_info_description: "In this section, you can add a company to the debtor.",
			/* ------------------------------ COMPANY INFO ------------------------------ */
			company_info_title: "Add Company",
			company_invoice_description:
				"In this section, you can fill in the invoice details of the company to be created.",
			/* ---------------------------- COMPANY INVOICE INFO -------------------------- */
			company_invoice_title: "Invoice Details",
			debtor_account_description:
				"Here you can add existing users to a debtor or invite a new user and add them directly.",
			/* ------------------------------- ADD ACCOUNT ------------------------------ */
			debtor_account_title: "Add User",
			debtor_groups: {
				label: "Debtor Groups",
				placeholder: "Resellers",
			},
			debtor_info_description: "Debtor Information",
			/* ------------------------------- DEBTOR INFO ------------------------------ */
			debtor_info_title: "Debtor Information",
			debtor_name: {
				label: "Debtor Name",
				placeholder: `${company_name}`,
			},
			debtor_type: {
				business: "Business",
				label: "Type",
				placeholder: "Business",
				private: "Private",
			},
			different_invoice: {
				label: "Different Invoice Details?",
				no: "No",
				yes: "Yes",
			},
			email_address: {
				label: "Email Address",
				placeholder: `info@${company_name}.nl`,
			},
			emergency_number: {
				label: "Emergency Number",
				placeholder: "0612345678",
			},
			internal_note: {
				label: "Internal Note",
				placeholder: "Internal Note",
			},
			invoices_email_address: {
				label: "Invoices Email Address",
				placeholder: `administratie@${company_name}.nl`,
			},
			kvk_number: {
				label: "Chamber of Commerce Number",
				placeholder: "12345678",
			},
			never_invoice: {
				description: "Never invoice this debtor",
				label: "Never Invoice",
			},
			paid_services_disabled: {
				description: "Exclude paid services",
				label: "Paid Services",
			},
			username: {
				label: "Username",
				placeholder: `${company_name}`,
			},
		},
		title: "Add Debtor",
	},
	edit_debtor: {
		form: {
			company_address_description:
				"In this section, you can edit the invoice details of the company.",
			company_communication_description:
				"In this section, you can edit the address details of the company.",
			company_info_description: "In this section, you can edit the company of the debtor.",
			company_info_title: "Edit Company",
			company_invoice_description:
				"In this section, you can edit the invoice details of the company.",
		},
		title: "Edit Debtor",
	},
	import_button: "Import Debtor",
	membership_type: {
		business: "Business",
		label: "Select debtor type",
		private: "Private",
	},
	table: {
		company: "Company",
		debtor_code: "Debtor Number",
		details: "Details",
		family_name: "Family Name",
		given_name: "Given Name",
		middle_name: "Middle Name",
		name: "Name",
		type: "Type",
	},
	title: "Debtors",
};

export default debtors;
